<template>
  <div class="product-options">
    <div class="options-top-bar " ref="optionsTopBar" >
      <h6 class="pull-left">{{$t('catalogProd.single')}} {{$t('catalogProdOpt.plural')}}</h6>
      <div class="text-right">
        <p class="">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success btn">{{$t('general.update')}}</button>
        </p>
      </div>
    </div>

    <div class="options-content"
            :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}"
            ref="optionsContainer">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <form class="clearfix ">
            <p class="text-danger" v-show="errors.has('error')">
              {{ getError('error') }}
            </p>
            <table class="table align-top">
              <thead>
                  <tr>
                    <th width="50px"></th>
                    <th>{{$t('catalogProdOpt.name')}}</th>
                    <th>{{$t('catalogProdOpt.type')}}</th>
                    <th>{{$t('catalogProdOpt.values')}} - {{$t('catalogProdOpt.posid')}}</th>
                    <th width="60px"></th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="(option, key) in model.products_options">
                  <td><button class="btn btn-icon btn-danger" @click.prevent="deleteOption(option.id)" :title="$t('general.remove') + ' ' + $t('catalogProdOpt.single')"><i class="ti-trash"></i></button></td>
                  <td>
                    <input type="text"
                            :placeholder="$t('catalogProdOpt.name')"
                            class="form-control"
                            v-model="option.name"
                            v-validate="modelValidate.required">
                  </td>
                  <td>
                    <select v-model="option.type" class="form-control">
                      <option v-for="(opt, key) in optionTypes" :value="key">{{opt}}</option>
                    </select>
                  </td>
                  <td>
                    <template v-for="(val, key) in option.values">
                      <input type="text"
                              placeholder=""
                              class="form-control sml mar-bt-5"
                              v-model="val.label"
                              v-validate="modelValidate.required">
                      <input type="text" 
                              :placeholder="$t('catalogProdOpt.posid')" 
                              class="form-control sml mar-bt-5" 
                              v-model="val.pos_id">
                      <button class="btn btn-simple btn-icon" @click.prevent="deleteValue(option.id, val.id)"><i :title="$t('general.delete')" class="ti-close text-orange"></i></button>
                      <br/>
                    </template>
                    <button class="btn btn-simple btn-icon " @click.prevent="addNewValue(option.id)"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogProdOpt.value')}}</button>
                  </td>
                  <td>
                  <button class="btn btn-icon btn-info" @click.prevent="duplicateOption(option.id)" :title="$t('general.duplicate') + ' ' + $t('catalogProdOpt.single')"><i class="ti-files"></i></button></td>
                </tr>
                <tr >
                  <td colspan="5"><button class="btn btn-icon btn-info" @click.prevent="addNewOption()"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogProdOpt.single')}}</button></td>
                </tr>
              </tbody>
            </table>

           <!-- <div class=" text-center pad-to-15 pad-bt-15">
              <button type="submit" class="btn btn-fill btn-success btn-wd" @click.prevent="validate">{{$t('general.update')}}</button>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input
    },
    props: {
      // modeldata: {}
    },
    watch: {
      // modeldata (value) {
      //   this.model = value
      // }
    },
    data () {
      return {
        model: [],
        modelValidate: {
          name: {required: true},
          required: {required: true}
        },
        optionTypes: {
          'checkbox': this.$t('checkbox'),
          'radio': this.$t('radio')
        },
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true
      }
    },
    created () {
      this.$nextTick(function () {
        this.loading = true
      })
      var data = {
        token: this.$session.get('token')
      }
      var self = this
      var companyID = this.$session.get('selectedCompany')

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          self.defaultData = response.data[0]
        }
      })

      this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
        if (response2.status === true) {
          self.model = response2.data[0]
          self.$nextTick(function () {
            self.loading = false
          })
        }
      })
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      addNewValue (optId) {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = {
              'id': null,
              'label': ''
            }
            newRow.id = response.data[0].id

            var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options)

            // self.model.products_options[optIdx].values.push(newRow)

            let zElement = Object.values(self.model.products_options).filter(function (element) {
              return element.id === optId
            })

            if (Array.from(zElement[0].values).length === 0) {
              zElement[0].values = Array.from(Object.values(zElement[0].values))
            }

            zElement[0].values.push(newRow)
          }
        })
      },
      addNewOption () {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes',
          'counter': 2
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = {
              'id': null,
              'name': '',
              'type': '',
              'values': []
            }
            newRow.id = response.data[0].id

            let newOption = {
              'id': null,
              'label': ''
            }
            newOption.id = response.data[1].id

            newRow.values.push(newOption)

            if (!self.model.products_options) {
              self.model.products_options = []
            }

            self.model.products_options.push(newRow)
          }
        })
      },
      duplicateOption (optId) {
        let counter = 1

        var optIdx = this.getObjectByElemKeyValue('id', optId, this.model.products_options)
        counter += this.model.products_options[optIdx].values.length

        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes',
          'counter': counter
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newOpt = self.copyObject(self.model.products_options[optIdx])
            console.table(newOpt)
            newOpt.id = response.data[0].id
            let i = 1
            for (let idx in newOpt.values) {
              newOpt.values[idx].id = response.data[i].id
              i++
            }
            self.model.products_options.push(newOpt)
          }
        })
      },
      deleteValue (optId, valId) {
        var optIdx = this.getObjectByElemKeyValue('id', optId, this.model.products_options)
        var valIdx = this.getObjectByElemKeyValue('id', valId, this.model.products_options[optIdx].values)

        this.model.products_options[optIdx].values.splice(valIdx, 1)
      },
      deleteOption (optId) {
        var self = this
        swal({
          text: self.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              product_option_id: optId
            }
            this.apiRequest('/settings/usage', 'POST', data, function (response) {
              if (response.status) {
                var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options)
                self.model.products_options.splice(optIdx, 1)
              } else {
                console.warn(response)
                var msg = response.errors['product_option_id'] ? response.errors['product_option_id'] : self.$t('validations.wentWrong')
                swal(
                  '',
                  msg,
                  'error'
                )
              }
            })
          }
        }).catch(() => {
         //
        })
      },
      saveDetails () {
        this.$nextTick(function () {
          this.loading = true
        })
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'products_options': JSON.stringify(this.model.products_options)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('catalogProdOpt.optionSaved'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/ProductOptions.vue